import ReactGA from "react-ga4";

const useAnalyticsEventTracker = (category="Checkins") => {
    const eventTracker = (action = "Start checkin") => {
        ReactGA.event({category, action});
    }
    return eventTracker;
}

export default useAnalyticsEventTracker;